<template>
  <div class="mb-3">
    <AlertLink link="/user-guide#Variables" text="Read more about variables here"></AlertLink>
    <p>Variables are used to label the data. Just add double brackets around variable name to use created variables in chats.</p>
    <p>Example: Hi user, Visit our offer page to get discounts {{"{{ offer_page_url }"}}}</p>
    <p>List is is also a varibale but it can hold more than one value.</p>

    <Alert v-if="showWarning" text="Variable name must be single word. use underscore to seperate the words." type="alert-danger"></Alert>

    <div class="mb-3" v-for="(item, index) in variables" :key="index">
      <div class="row" v-if="Array.isArray(item.value)">
        <div class="col pr-0">
          <div class="input-group">
            <input type="text" class="form-control" v-model="item.variable" placeholder="List name" @input="checkVariable(item)">
            <div class="input-group-append">
              <button @click="removeVariable(index)" class="btn btn-outline-danger">X</button>
            </div>
          </div>
        </div>
        <div class="col pl-0">
          <div v-for="(val, i) in item.value" :key="i">
            <div class="input-group">
              <input type="text" class="form-control" v-model="item.value[i]" placeholder="value">
              <div class="input-group-append">
                <button @click="removeVariableValue(index, i)" class="btn btn-outline-danger">X</button>
              </div>
            </div>
          </div>
          <button @click="addVariableValue(index)" class="btn btn-outline-success btn-block">Add Value</button>
        </div>
      </div>

      <div class="input-group" v-else>
        <input type="text" class="form-control" v-model="item.variable" placeholder="Variable name" @input="checkVariable(item)">
        <input type="text" class="form-control" v-model="item.value" placeholder="value">
        <div class="input-group-append">
          <button @click="removeVariable(index)" class="btn btn-outline-danger">X</button>
        </div>
      </div>

    </div>
 
    <div class="btn-group mb-5">
      <button @click="addVariable('single')" class="btn btn-outline-info">Create Variable</button>
      <button @click="addVariable('multiple')" class="btn btn-outline-info">Create List</button>
    </div>
    
  </div>
</template>


<script>
import AlertLink from "@/components/AlertLink.vue";
import Alert from "@/components/Alert.vue";




export default{
  name: 'Variables',
  components:{
    AlertLink,
    Alert
  },
  data: function(){
    return {
      showWarning: false
    }
  },
  props:{
    variables: Array
  },
  methods: {
    removeVariable: function(index){
      this.$emit('removeVariable',index);
    },
    removeVariableValue:  function(index, i){
      this.$emit('removeVariableValue',index, i);
    },
    addVariable: function(var_type){
      this.$emit('addVariable',var_type);
    },
    addVariableValue: function(index){
      this.$emit('addVariableValue', index);
    },
    checkVariable: function(item){
      let name = item.variable
      if(name.substr(-1) == " "){
        item.variable = name.substr(0, name.length-1)
        this.showWarning = true
      }
    }
  }
}
</script>
